module.exports = __webpack_public_path__ + "static/media/036-support-1.b2f399a0.svg";